import { defineComponent, // ref,
// watch,
computed } from "vue";
import { definePropType } from "@types-vue/props";
import _ from "lodash";
export default defineComponent({
    components: {},
    props: {
        data: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        labelKey: {
            type: String,
            default: "name"
        },
        tail: {
            type: String,
            default: "..."
        },
        limit: {
            type: Number,
            default: 1
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var innerList = computed(function() {
            var list = props.data.filter(function(item) {
                return Boolean(item[props.labelKey]);
            });
            return _.uniq(list.map(function(item) {
                return item[props.labelKey];
            }));
        });
        var referenceLabel = computed(function() {
            if (props.data.length) {
                var firstItem = props.data[0];
                return firstItem[props.labelKey];
            }
            return "-";
        });
        return {
            innerList: innerList,
            referenceLabel: referenceLabel
        };
    }
});
